import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Component({ template: '' })
export abstract class AbstractInputComponent implements OnInit, OnDestroy {
  @Input()
  public labelWidth: 2 | 3 | 4 | 5 | 6 = 3;

  @Input()
  public label: string;

  @Input()
  public inputStyleClass = 'px-2 py-1 w-full rounded-md';

  @Input()
  public property: string;

  @Input()
  public item: any;

  @Input()
  public required: boolean;

  @Input()
  public disabled: boolean;

  @Input()
  public control: FormControl;

  @Input()
  public validateOn: 'change' | 'blur' | 'submit' = 'change';

  @Input()
  public validators: ValidatorFn | ValidatorFn[];

  public form: FormGroup;

  public labelStyleClass: string;
  public inputWrapperStyleClass: string;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnDestroy(): void {
    if (this.form && this.property) {
      this.removeFormControl();
    }
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup?.control;
    this.labelStyleClass = 'px-1 mt-1 w-' + this.labelWidth + '/12';
    this.inputWrapperStyleClass = 'w-' + (12 - this.labelWidth) + '/12';
    if (this.form && this.property) {
      this.addFormControl();
    }
  }

  protected addFormControl(): void {
    if (!this.control) {
      this.control = new FormControl(
        {
          value: this.item[this.property],
          disabled: this.disabled,
        },
        {
          validators: this.createValidators(),
          updateOn: this.validateOn,
        },
      );
      this.form.addControl(this.property, this.control);
    }
  }

  protected removeFormControl(): void {
    if (this.property) {
      this.form.removeControl(this.property);
    }
  }

  protected createValidators(): ValidatorFn[] {
    const validators = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.validators) {
      if (Array.isArray(this.validators)) {
        validators.push(...this.validators);
      } else {
        validators.push(this.validators);
      }
    }
    return validators;
  }
}
